import styled from "styled-components";

export default styled.div`
  display: flex;
  justify-content: center;
  height: 350px;
  width: auto;
  border-radius: 5px;
  color: black;
  margin-left: 10px;
  cursor: pointer;
`;